import * as types from "./actionTypes";

export const togglePriceWorksheetOpened = (priceWorksheetOpened) => ({
  type: types.TOGGLE_PRICE_WORKSHEET_OPENED,
  payload: {
    priceWorksheetOpened
  }
});

// export const setDiscountSections = (discountSections) => {
//   return (dispatch, getState) => {
//     const {financeCellsVisible} = getState().priceWorksheetState;
//     //     if (currentSection) {
//     //       const discounts = sortByOrder(currentSection.discounts).filter((disc) => !disc.nestedParent);
//     //     }
//     const payload = {
//       discountSections,
//     }
//     if (financeCellsVisible.length !== Object.keys(DISCOUNT_FINANCE_CELLS).length) {
//       const sectionWithFinance = discountSections.find(sec => {
//         return sec.type !== DISCOUNT_SECTION_TYPES.finance && sec.discounts.some(discount => {
//           return discount.discountType === DISCOUNT_SECTION_TYPES.finance
//         })
//       });
//       if (sectionWithFinance) {
//         sectionWithFinance.discounts
//       }
//     }
//     dispatch({
//       type: types.SET_DISCOUNT_SECTIONS,
//       payload
//     })
//   }
// };
export const setDiscountSections = (discountSections) => ({
  type: types.SET_DISCOUNT_SECTIONS,
  payload: {
    discountSections,
  }
});

export const setCustomAddedDiscounts = (customAddedDiscounts) => ({
  type: types.SET_CUSTOM_ADDED_DISCOUNTS,
  payload: {customAddedDiscounts}
})

export const setFinancePercentage = (financePercentage) => ({
  type: types.SET_FINANCE_PERCENTAGE,
  payload: {financePercentage}
});

export const setAllFinanceOptionsPopupVisible = (allFinanceOptionsPopupVisible) => ({
  type: types.SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE,
  payload: {allFinanceOptionsPopupVisible}
});

export const setFinanceCellsVisible = (financeCellsVisible) => ({
  type: types.SET_DISCOUNT_FINANCE_CELLS_VISIBLE,
  payload: {financeCellsVisible}
});
